import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Avoid initializing Sentry in non-production builds: the browser SDK wraps errors and
// can throw internally (known issues with regexp/stack handling in eventbuilder) which
// pollutes the console during local development and dialog interactions.
if (environment.production && environment.sentry?.dsn) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    tracesSampleRate: environment.sentry.tracesSampleRate,
    sendDefaultPii: true,
  });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch((err) => console.error(err));
